import { UsagePeriod, formatDatePeriod } from "../helper";

const DropdownContent = ({
  recentSubscriptions,
}: {
  recentSubscriptions: Array<UsagePeriod>;
}) => {
  const onPeriodClicked = (period: UsagePeriod) => {
    const queryParams = new URLSearchParams(window.location.search);

    queryParams.set("from", period.start_date);
    queryParams.set("to", period.end_date);
    window.location.search = queryParams.toString();
  };

  return (
    <div className="px3 py2">
      <ul className="list-reset">
        {recentSubscriptions.map((subscriptionPeriod) => (
          <li key={subscriptionPeriod.start_date}>
            <button
              className="m0 col col-12 p2 h4 bg-white border-none text-left hover-purple cursor-pointer button"
              onClick={() => onPeriodClicked(subscriptionPeriod)}
            >
              {formatDatePeriod(subscriptionPeriod)}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DropdownContent;
